import { useQuery } from 'react-query';
import { get } from 'Core/utils/platformApi';
import cacheKeys from 'Core/hooks/queries/cacheKeys';
import useAlertStore, { setErrorAlertSelector } from 'Core/stores/alert';
import { useTranslation } from 'react-i18next';

export default function useGetLatestRequest(requestId, customerGid, externalReferenceId, enabled = false) {
  const { t } = useTranslation();
  const setErrorAlert = useAlertStore(setErrorAlertSelector);

  const isEnabled = Boolean(enabled && requestId && customerGid && externalReferenceId);

  return useQuery(
    [cacheKeys.easyCreditLatestRequest, requestId, customerGid, externalReferenceId],
    () => {
      return get('/financing/applications/latest-request', {
        headers: {
          request_id: requestId,
          customer_gid: customerGid,
          external_reference_id: externalReferenceId,
        },
      });
    },
    {
      enabled: isEnabled,
      refetchInterval: (data) => {
        if (data?.data?.application?.easycredit_redirect_link?.redirect_link) {
          return false;
        }
        return 3000;
      },
      onError(error) {
        setErrorAlert(
          t('status.error.getLatestRequestFailed') + ` (${error?.response?.data?.message || error.message})`
        );
      },
    }
  );
}

